import { FC, useContext, useEffect, useMemo, useState } from 'react';
import { IEventMetadata, IFormFieldMetadata, IFormMetadata, IFormSectionMetadata, IFormVersionMetadata, ISourceData, ISourceDataConfiguration, ISourceDataConfigurationEvent, ISourceDataConfigurationForm, ISourceDataConfigurationFormSection, ISourceDataConfigurationFormVersion, ISourceDataEvent, ISourceDataField, ISourceDataForm, ITrialFormMetadata } from '@/api/dtos';
import { BasicAlert, Checkbox, CollapsiblePanel, ICollapsiblePanelComponentProps, InputOnlyField, Select } from '@ngt/forms';
import { alpha, Box, Button, Chip, Divider, styled, Tooltip, Typography, lighten, darken, TextField, MenuItem } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarDays, faCodeBranch, faRepeat, faSquareList } from '@fortawesome/pro-duotone-svg-icons';
import { faExclamationTriangle, faInfoCircle } from '@fortawesome/pro-light-svg-icons';
import { ISourceDataFormFieldComponentProps } from '@/utilities/forms/SourceDataFormProcessor';
import SourceDataFormField from '../common/SourceDataFormField';

const Title = styled(Typography)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    padding: theme.spacing(2)
}));

const IconContainer = styled(Box)(({ theme }) => ({
    marginRight: theme.spacing(2)
}));

const RepeatChip = styled(Chip)(({ auto, theme }: any) => ({
    marginLeft: auto ? 'auto' : theme.spacing(1)
}));

const Content = styled(Box)(({ theme }) => ({
    padding: theme.spacing(2, 2, 2, 2),
    display: 'flex',
    alignItems: 'flex-start',
    
    borderRight: theme.palette.mode === 'dark' ? 
        `solid 1px ${alpha(theme.palette.common.white, 0.12)}` :
        `solid 1px ${alpha(theme.palette.common.black, 0.12)}`
}));

const Wrapper = styled(Box)(({ section, theme }: any) => ({
    marginLeft: theme.spacing(section === '1' ? 24 : 16),
    borderLeft: theme.palette.mode === 'dark' ? 
        `solid 1px ${alpha(theme.palette.common.white, 0.12)}` :
        `solid 1px ${alpha(theme.palette.common.black, 0.12)}`,
    borderRight: theme.palette.mode === 'dark' ? 
        `solid 1px ${alpha(theme.palette.common.white, 0.12)}` :
        `solid 1px ${alpha(theme.palette.common.black, 0.12)}`
}));

const SourceDataFormFieldExpanding: FC<ISourceDataFormFieldComponentProps> = (props) => {
    return (
        <Wrapper
            // @ts-ignore
            section={!props.formSectionMetadata ? undefined : '1'}
        >
            <SourceDataFormField {...props} />
            <Divider />
        </Wrapper>
    );
}

export default SourceDataFormFieldExpanding;